import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastContainerComponent } from '@ps-gui/shared-core';
import { Toast } from 'primeng/toast';
import { CtHeaderComponent, SharedCtBatchStoreService } from '@ps-gui/claims-terminal-shared';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'ct1-root',
  templateUrl: './app.component.html',
  imports: [RouterModule, Toast, CtHeaderComponent, AsyncPipe, ToastContainerComponent],
})
export class AppComponent {
  protected readonly ctBatchStoreService = inject(SharedCtBatchStoreService);
}
